import { render } from "./EhrFieldSearchTab.vue?vue&type=template&id=5b16f88a&scoped=true"
import script from "./EhrFieldSearchTab.vue?vue&type=script&lang=js"
export * from "./EhrFieldSearchTab.vue?vue&type=script&lang=js"

import "./EhrFieldSearchTab.vue?vue&type=style&index=0&id=5b16f88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b16f88a"]])

export default __exports__